export const getScrollBarWidth = () => {
  const elem = document.createElement("div");
  elem.style.cssText = "overflow:scroll; visibility:hidden; position:absolute;";
  document.body.appendChild(elem);
  const width = elem.offsetWidth - elem.clientWidth;
  elem.remove();
  return width;
};
